import { toDate as r } from "./toDate.js";
function e(o) {
  const t = r(o);
  return t.setHours(0, 0, 0, 0), t;
}
export {
  e as default,
  e as startOfDay
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/startOfDay.js
// module id = 307
// module chunks = 67